import { render, staticRenderFns } from "./CopaymentTag.vue?vue&type=template&id=694d9e83&scoped=true&"
import script from "./CopaymentTag.vue?vue&type=script&lang=js&"
export * from "./CopaymentTag.vue?vue&type=script&lang=js&"
import style0 from "./CopaymentTag.vue?vue&type=style&index=0&id=694d9e83&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694d9e83",
  null
  
)

export default component.exports